export const AGENTS_API_TOKEN_NAME = 'AGENTS_API';

export const DefaultAgentsApiConfig = {
    debug: false,
    useUnauthorizedInterceptor: true,
    withCredentials: true,
};
